import { render, staticRenderFns } from "./projectdetail.vue?vue&type=template&id=68182b16&scoped=true"
import script from "./projectdetail.vue?vue&type=script&lang=js"
export * from "./projectdetail.vue?vue&type=script&lang=js"
import style0 from "./projectdetail.vue?vue&type=style&index=0&id=68182b16&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68182b16",
  null
  
)

export default component.exports